export default function () {
  const dataHref = document.querySelectorAll('[data-href]');

  if (dataHref !== null) {
    dataHref.forEach(el => {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        let href = el.getAttribute('data-href');
        let target = el.getAttribute('data-target');

        if (target) {
          window.open(href, target).focus();
        } else {
          if (Turbo) {
            Turbo.visit(href);
          } else {
            window.location = href;
          }
        }
      });
    });
  }
}
